import { create } from 'zustand'
import type { CrisisContact, User } from './types'

type AuthState = {
  user: User | null
  isAuthenticated: boolean
  isLoading: boolean
  setUser: (user: User | null) => void
  setLoading: (loading: boolean) => void
  reset: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  setUser: (user) => set({ user, isAuthenticated: !!user }),
  setLoading: (isLoading) => set({ isLoading }),
  reset: () => set({ user: null, isAuthenticated: false, isLoading: false }),
}))

type MessageLimitStatus = {
  exceeded: boolean
  resetTime: string
  /** Лимит упёрся в разговор с признаками кризиса — вместо ценника контакты помощи. */
  crisis?: boolean
  contacts?: CrisisContact[]
} | null

type UIState = {
  activeConversationId: string | null
  isStreaming: boolean
  messageLimitStatus: MessageLimitStatus
  groupAiBusy: Record<string, boolean>
  setActiveConversationId: (id: string | null) => void
  setStreaming: (v: boolean) => void
  setMessageLimitStatus: (status: MessageLimitStatus) => void
  setGroupAiBusy: (dialogId: string, busy: boolean) => void
}

export const useUIStore = create<UIState>((set) => ({
  activeConversationId: null,
  isStreaming: false,
  messageLimitStatus: null,
  groupAiBusy: {},
  setActiveConversationId: (id) => set({ activeConversationId: id }),
  setStreaming: (isStreaming) => set({ isStreaming }),
  setMessageLimitStatus: (messageLimitStatus) => set({ messageLimitStatus }),
  setGroupAiBusy: (dialogId, busy) =>
    set((state) => ({
      groupAiBusy: { ...state.groupAiBusy, [dialogId]: busy },
    })),
}))
